import { Middleware } from "@reduxjs/toolkit";

import { PlayerService } from "src/services";
import { playerActions } from "src/store/actions";

export const playerMiddleware =
  (player: PlayerService): Middleware =>
  () =>
  (next) =>
  (action) => {
    const response = next(action);

    switch (action.type) {
      case playerActions.start.type: {
        player.play();
        break;
      }
      case playerActions.stop.type: {
        player.stop();
        break;
      }
    }

    return response;
  };
